import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Styling = styled.div`
  position: fixed;
  bottom: 20px;
  left: 20px;
  background: rgba(0, 0, 0, 0.95);
  min-width: 300px;
  max-width: 400px;
  padding: 1rem;
  z-index: 10000;
  color: var(--white);
  font-family: var(--font_body);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

  .processing {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #4caf50;

    .spinner {
      width: 16px;
      height: 16px;
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-top: 2px solid #4caf50;
      border-radius: 50%;
      animation: ${spin} 1s linear infinite;
    }
  }

  .error {
    color: #f44336;
    background: rgba(244, 67, 54, 0.1);
    padding: 0.5rem;
    border-radius: 4px;
    border-left: 3px solid #f44336;
    margin-bottom: 0.5rem;

    strong {
      display: block;
      margin-bottom: 0.25rem;
    }
  }

  .success {
    color: #4caf50;
    background: rgba(76, 175, 80, 0.1);
    padding: 0.5rem;
    border-radius: 4px;
    border-left: 3px solid #4caf50;
    margin-bottom: 0.5rem;

    strong {
      display: block;
      margin-bottom: 0.25rem;
    }

    ul {
      margin: 0;
      padding-left: 1rem;
      list-style-type: disc;

      li {
        margin-bottom: 0.25rem;
        font-size: 0.9rem;
      }
    }
  }

  .debug {
    color: #ff9800;
    background: rgba(255, 152, 0, 0.1);
    padding: 0.5rem;
    border-radius: 4px;
    border-left: 3px solid #ff9800;
    font-size: 0.9rem;

    strong {
      display: block;
      margin-bottom: 0.25rem;
    }
  }

  /* Hide by default, only show when there's content */
  &:empty {
    display: none;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    top: 10px;
    right: 10px;
    left: 10px;
    min-width: auto;
    max-width: none;
  }
`;

export { Styling };
